// menu-items/index.js

import { dashboard, companies, marketing } from 'menu-items/dashboard';
import pages from './page';
import utilities from './utilities';
import support from './support';

export const getMenuItems = () => {
  const role = localStorage.getItem('role');
  if (role === 'SUPER_ADMIN') return { items: [dashboard] };
  if (role === 'MARKETING') return { items: [marketing] };
  return { items: [companies] };
};

export default getMenuItems();
